<template>
  <div>
    <div class="form-row">
      <div class="form-group col-md">
        <treeselect
          instance-id="client"
          v-model="clientValue"
          :auto-load-root-options="false"
          :placeholder="$t('Webportal.ClientFilter.Placeholder')"
          :options="clientItems"
          :disabled="disabledInternal"
          :disableFuzzyMatching="true"
          :multiple="multipleClientSelectionInternal"
          :disable-branch-nodes="!multipleClientSelectionInternal"
          :showCount="true"
          showCountOf="LEAF_DESCENDANTS"
          valueFormat="object"
          @close="loadData"
          @input="filterInput"
        >
        </treeselect>
      </div>
      <div v-if="propertySelection" class="form-group col-md">
        <treeselect
          instance-id="property"
          v-model="propertyValue"
          :auto-load-root-options="false"
          :placeholder="$t('Webportal.PropertyValueFilter.Placeholder')"
          :options="propertyItems"
          :disableFuzzyMatching="true"
          :disabled="disabledInternal || propertySelectDisabled"
          :multiple="true"
          :showCount="true"
          showCountOf="LEAF_DESCENDANTS"
          :defaultExpandLevel="1"
          :disable-branch-nodes="false"
          value-consists-of="LEAF_PRIORITY"
          :limit="4"
          :limit-text="limitText"
          @close="loadData"
          @input="filterInput"
        >
        </treeselect>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';

import SurveysService from '@/services/SurveysService';
import AdministationService from '@/services/AdministationService';

export default {
  name: "ClientFilter",

  mixins: [ AppConfig ],

  props: {
    value: null,
    disabled: { default: false },
    multipleClientSelection: { default: true },
    propertySelection: { default: true },
    autoSelect: { default: false }
  },

  data() {
    return {
      disabledInternal: this.disabled,
      multipleClientSelectionInternal: this.multipleClientSelection,

      clientValue: this.multipleClientSelectionInternal ? [] : null,
      clientItems: [],
      propertyItems: [],
      propertyValue: [],

      currentClientValue: null,
      currentFilter: null,
    }
  },

  computed: {
    waveSelectDisabled() {
      return !this.multipleClientSelectionInternal && _.isEmpty(this.clientValue);
    },

    scenarioSelectDisabled() {
      return !this.multipleClientSelectionInternal && _.isEmpty(this.clientValue);
    },

    propertySelectDisabled() {
      return _.isEmpty(this.clientValue);
    },

    filter() {
      return !this.propertySelection && !this.multipleClientSelection ?
        this.clientValue?.id :
        {
          clientIds: Array.isArray(this.clientValue) ? this.clientValue.map(item => item.id) : this.clientValue ? [ this.clientValue.id ] : [],
          propertyIds: this.propertyValue,
          propertyUseLogicalAnd: false
        };
    },
  },

  watch: {
    currentFilter(newVal, oldVal) {
      this.$emit("input", newVal);
    },

    disabled(newVal, oldVal) {
      this.disabledInternal = newVal;
    },

    disabledInternal(newVal, oldVal) {
      this.$emit("disabledChanged", newVal);
    },
  },

  mounted() {
    this.getClients();
  },

  methods: {
    getClients() {
      AdministationService.getClientSettings()
        .then(response => {
          this.clientItems = response.data.map(item => {
              return { id: item.ClientId, label: item.ClientName };
          });

          if (this.autoSelect && this.clientItems.length === 1)
            this.clientValue = this.clientItems[0];
        })
    },

    getSurveyProperties() {
      if (!this.propertySelectDisabled)
      {
        this.propertyItems = [];
        SurveysService.getSurveyCustomProperties(this.filter, true)
          .then(response => {
            this.propertyItems = response.data;
          })
      }
    },

    // Called whenever the input of a treeselect control changes
    filterInput(value, instanceId) {
      // Workaround: Only call data loading when clear all is pressed
      if (_.size(value) === 0 || (!this.multipleClientSelection && instanceId == "client"))
        this.loadData();
    },

    // Applies changed filter and triggers data loading if necessary
    loadData() {
      // Only load data when effective filter has changed
      if (!_.isEqual(this.filter, this.currentFilter)) {
        let clientValueChanged = !_.isEqual(this.currentClientValue, this.clientValue);
        this.currentClientValue = this.clientValue;
        if (clientValueChanged)
        {
          this.propertyValue = [];
        }

        this.currentFilter = this.filter;

        if (clientValueChanged && this.propertySelection)
        {
          this.getSurveyProperties();
        }
      }
    },
  }
}
</script>
